<template>
  <div>
    <v-select
      v-if="isReportApproved"
      :items="statuses"
      item-text="name"
      item-value="value"
      v-model="selectedStatus"
      @change="updateStatus"
      class="selectbox"
      outlined
      dense
    ></v-select>
    <v-select
      v-if="isShowDownloadOption"
      :items="downloadReportOptions"
      item-text="name"
      item-value="value"
      @change="updateDownloadStatus"
      v-model="selectedDownloadOption"
      class="selectbox mr-3"
      outlined
      dense
      :placeholder="$t('memberDataSection.download')"
    ></v-select>
    <v-btn
      v-if="diligenceId"
      color="#F03737"
      dark
      medium
      class="mr-3"
      @click="discard"
    >
      {{ $t('deforestation.discard')}}
    </v-btn>
    <v-btn
      v-if="diligenceId && !isSupplierOperatorOnly"
      color="#FFB443"
      dark
      medium
      class="mr-3"
      @click="reject"
    >
      {{ $t('deforestation.reject')}}
    </v-btn>
    <v-btn v-if="showRequestAdditionalInformation" color="primary" dark medium class="mr-3" @click="requestAdditionalInformation">
      {{ $t('deforestation.requestAdditionalInformation')}}
    </v-btn>
    <v-btn
      color="primary"
      dark
      medium
      class="mr-3"
      v-if="!isFinalPage"
      @click="saveAndContinueLater"
    >
      {{ $t('deforestation.saveAndContinueLater')}}
    </v-btn>
    <v-btn v-if="!isFinalPage" color="primary" dark medium class="mr-3" @click="next">
      {{ $t('deforestation.next') }}
    </v-btn>
    <v-btn 
      color="primary" 
      dark 
      medium 
      class="mr-3"
      v-if="isFinalPage && !isShowDownloadOption"
      @click="approveDialog = true">
      {{ $t('deforestation.conclude') }}
    </v-btn>
    <v-btn
        color="primary"
        dark
        medium
        class="mr-3"
        v-if="isFinalPage && isSupplierOnly && isReportComplaintAndNonComplaint"
        @click="sendToOperatorDialog = true">
      {{ $t('deforestation.sendToOperator') }}
    </v-btn>
    <v-btn 
      color="primary" 
      dark 
      medium 
      class="mr-3"
      v-if="isFinalPage && isReportComplaintAndNonComplaint && isOperatorOperatorOwnerOnly"
      @click="handleEUDRUpload()"
      >
      {{ $t('deforestation.uploadToEudr') }}
    </v-btn>

    <SaveAndContinueDialog @confirm-save="confirmSaveAndContinueLater" @close-modal="closeSaveAndContinueDialog" :dialog="saveAndContinueDialog" />
    <confirm-download @confirm="triggerDownload" @close-modal="closeDownloadModel" :dialog="showConfirmation" />
    <RequestAdditionalInformation @close-modal="closeRequestAdditionalInformationDialog" v-if="requestAdditionalInformationDialog" :dialog="requestAdditionalInformationDialog" :supplierId="supplierId" :visibleSelectedTabs="visibleSelectedTabs"/>
    <DiscardDialog @close-modal="closeDiscardDialog" :dialog="discardDialog" />
    <RejectDialog @close-modal="closeRejectDialog" :dialog="rejectDialog" />
    <ApproveDialog @confirm-approval="confirmApproval" @close-modal="closeApproveDialog" :dialog="approveDialog" />
    <SendToOperatorDialog @confirm-send="confirmSend" @close-modal="closeSendToOperatorDialog" :dialog="sendToOperatorDialog" />

    <Seventy2HourConfirmation @finilize="handleFinilize" :dialog="confirmSeventyTwoHourModalOpen" @close-modal="handleWarningCloseModal" />
    <WarningModel :warnings="getWarnings" @handle-finilize="handleConfirmationWithError" @close-modal="handleWarningCloseModal" @gotoTab="handleTabs" :dialog="warningModalOpen" />
    <AfterWithErrorConfirmation :dialog="confirmSeventyTwoHourWithErrorModalOpen" @finilize="handleFinilize" @close-modal="handleWarningCloseModal"/> 

  </div>
</template>

<script>
import DiscardDialog from "./DiscardDialog.vue";
import RejectDialog from "./RejectDialog.vue";
import SendToOperatorDialog from  "./SendToOperatorDialog.vue";
import SaveAndContinueDialog from "./SaveAndContinueDialog.vue";
import ApproveDialog from './ApproveDialog.vue';
import ConfirmDownload from './ConfirmDownload.vue';
import RoleMixin from "@/mixins/RoleMixin";
import RequestAdditionalInformation from "./RequestAdditionalInformation.vue";

import Seventy2HourConfirmation from './final-conclude/72HourConfirmation.vue'
import WarningModel from './final-conclude/WarningModel.vue'
import AfterWithErrorConfirmation from './final-conclude/AfterWithErrorConfirmation.vue'

export default {
  components: {
    DiscardDialog,
    RejectDialog,
    SaveAndContinueDialog,
    RequestAdditionalInformation,
    ApproveDialog,
    SendToOperatorDialog,
    ConfirmDownload,
    Seventy2HourConfirmation,
    WarningModel,
    AfterWithErrorConfirmation
  },
  props: {
    supplierId: {
      required: false,
    },
    isFinalPage: {
      type: Boolean,
      required: false
    },
    reportStatus: {
      required: false
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    step: {
      type: Number,
      required: false
    }
  },
  watch: {
    '$route.params.id'(newVal) {
        if(newVal){
          this.diligenceId = newVal;
        }
      },
    },
  data() {
    return {
      testModelFlag:false,
      warningModalOpen:false,
      confirmSeventyTwoHourModalOpen:false,
      confirmSeventyTwoHourWithErrorModalOpen:false,

      diligenceId: this.$route.params.id || null,
      discardDialog: false,
      requestAdditionalInformationDialog:false,
      rejectDialog: false,
      saveAndContinueDialog:false,
      approveDialog: false,
      sendToOperatorDialog:false,
      selectedFormat: null,
      showConfirmation: false,
      statuses: [
        {
          name: this.$t("dueDiligence.selectStatus"),
          value:''
        },
        {
          name: this.$t('deforestation.compliant'),
          value:'Compliant'
        },
        {
          name:  this.$t('deforestation.nonCompliant'),
          value:'Non-Compliant'
        }
      ],

      reportStatuses: [
        {
          name: this.$t('deforestation.pending'),
          value:'Pending'
        },
        {
          name: this.$t('deforestation.underReview'),
          value:'Under Review'
        }
      ],
      downloadReportOptions:[
        {
          name:  this.$t('dueDiligence.downloadOptions'),
          value: ''
        },
        {
          name:  this.$t('dueDiligence.downloadAsPDF'),
          value: 'pdf'
        },
        {
          name:  this.$t('dueDiligence.downloadAsJSON'),
          value: 'json'
        },
      ],
      selectedDwReport:'',
      selectedStatus: '',
      selectedDownloadOption: '',
      selectedReportStatus: '',
      //selectedAssessments: [] // This will store objects
      visibleSelectedTabs: [],
    };
  },
  computed: {
    ddsActiveTab() {
      const ddsLocalData = this.$store.getters["getDDSLocalData"];
      return ddsLocalData?.activeTab || 1;
    },
    userRole() {
      return this.$store.getters["eudrDDS/getDdsUserRole"];
    },
    isSupplier() {
      return this.userRole === "supplier_owner" || "supplier";
    },
    isSupplierSubUser(){
      return this.userRole === "supplier";
    },
    isOperator() {
      return this.userRole === "operator_owner" || "operator";
    },
    isSupplierOnly(){
      return this.getCurrentRoles.includes("supplier_owner") || this.getCurrentRoles.includes("supplier")
    },
    isSupplierOperatorOnly(){
      return  this.getCurrentRoles.includes("supplier") || this.getCurrentRoles.includes("operator")
    },
    isOperatorOperatorOwnerOnly(){
      return  this.getCurrentRoles.includes("operator_owner") || this.getCurrentRoles.includes("operator")
    },
    isReportApproved() {
      return this.$props.reportStatus === "Compliant"
    },
    isReportComplaintAndNonComplaint(){
      return this.$props.reportStatus === "Compliant" ||  this.$props.reportStatus == 'Non-Compliant';
    },
    isShowDownloadOption(){
      return this.$props.reportStatus === 'Compliant' || this.$props.reportStatus == 'Non-Compliant'
    },
    showRequestAdditionalInformation(){
      return this.diligenceId && this.isOperatorOperatorOwnerOnly && this.step > 1
    },
    getWarnings()
    {
      return this.$store.getters["eudrDDS/getDetailWarnings"];
    }
  },
  mounted() {
    this.selectedStatus = this.$props.reportStatus;
  },
  methods: {
    closeApproveDialog() {
      this.approveDialog = false;
    },

    closeSendToOperatorDialog(){
      this.sendToOperatorDialog =false;
    },

    discard() {
      this.discardDialog = true;
    },
    closeDiscardDialog() {
      this.discardDialog = false;
    },

    reject() {
      this.rejectDialog = true;
    },
    closeRejectDialog() {
      this.rejectDialog = false;
    },
    requestAdditionalInformation() {
      this.visibleSelectedTabs = this.tabs.slice(1, this.tabs.length - 1);
      this.requestAdditionalInformationDialog = true;
    },
    closeRequestAdditionalInformationDialog() {
      this.requestAdditionalInformationDialog = false;
    },
    closeSaveAndContinueDialog(){
        this.saveAndContinueDialog = false
    },
    saveAndContinueLater() {
      this.saveAndContinueDialog = true;
    },
    confirmSaveAndContinueLater() {
      this.saveAndContinueDialog = false;
      this.$emit("saveAndContinueLater");
    },
    triggerDownload(pdfContent) {
      this.$emit('downloadReportType', this.selectedDownloadOption, pdfContent);
      this.showConfirmation = false;
      this.selectedFormat = null;
    },
    handleChangeDownload() {
      this.showConfirmation = true;
    },
    closeDownloadModel() {
      this.showConfirmation = false;
      this.selectedFormat = null;
    },
    updateStatus() {
      this.$emit("updateStatus", this.selectedStatus);
    },

    updateReportStatus() {
      this.$emit("updateReportStatus", this.selectedReportStatus);
    },

    updateDownloadStatus(){
      if(this.selectedDownloadOption === 'pdf'){
        this.showConfirmation = true;
      }
      else if(this.selectedDownloadOption === 'json'){
        this.$emit('downloadReportType', this.selectedDownloadOption);
      }
    },

    confirmSend(){
      this.sendToOperatorDialog = false;
      setTimeout(() => {
        this.$emit("sendToOperator");
      }, 500);
    },
    next() {
      this.$emit("nextStep");
    },
    handleEUDRUpload(){
      this.$notify({
        type: 'warning',
        title: 'Feature in Progress',
        text: 'This Feature is not available yet!!'
      });
      setTimeout(() => {
        this.$router.push({ name: "deforestation" });
      }, 500);
    },
    handleTabs(tab){
      this.$emit('handleTab',tab)
    },
    confirmApproval() {
      this.approveDialog = false;
      this.showWarningAndConfirmationBox()
    },
    showWarningAndConfirmationBox() {
       if(this.getWarnings?.length){
         this.warningModalOpen = true
         return
       }
       this.confirmSeventyTwoHourModalOpen = true
    },
    handleConfirmationWithError(){
      this.warningModalOpen = false
      this.confirmSeventyTwoHourWithErrorModalOpen = true
    },
    handleFinilize(publishOption){
      this.$emit("approveReport",publishOption);
    },
    handleWarningCloseModal(){
      this.warningModalOpen = false
      this.confirmSeventyTwoHourModalOpen = false
      this.confirmSeventyTwoHourWithErrorModalOpen = false
    }
  },
  mixins:[RoleMixin]
};
</script>

<style scoped>
.selectbox {
  display: inline-block !important;
  margin-right: 24px !important;
  transform: translateY(2px);
  width: 250px;
}
</style>
